const labels = {
  de: {
    global: {
      headline: 'Ausstellerverzeichnis',
      searchPlugin: 'Suchen Sie hier nach Ausstellern, Produkten und News...',
      description: 'In unserem Ausstellerverzeichnis können Sie nach allen Ausstellern und Mitausstellern, Partnern und Produkten recherchieren.',
    },
    navigation: {
      woozle: 'Woozle',
      programmList: 'Programmliste',
      hallPlan: 'Hallenplan'
    },
    filter: {
      open: 'Filter einblenden',
      close: 'Filter ausblenden',
      button: 'Filtern',
      sort: 'Sortieren',
      category: 'Kategorie',
      travelDestination: 'Reiseziel',
      spaces: 'Orte',
      ics: 'ICS Congresscenter',
      save: 'Speichern',
      reset: 'Zurücksetzen',
      cancel: 'Abbrechen',
      search: {
        placeholder: 'Bitte Suchbegriff eingeben',
        submit: 'Suchen',
        reset: 'Zurücksetzen',
      },
      tree: {
        placeholder: 'durchsuchen...',
        fairGroups: '',
        clearValue: 'Filter entfernen',
        clearAll: 'Filter zurücksetzen',
        noOptions: 'Keine Filter gefunden',
        noResults: 'Keine Ergebnisse gefunden',
        noChildren: 'Keine Unterpunkte gefunden',
        fairTree: {
          headline: 'Teilmessen',
        },
        typeTree: {
          headline: 'Eintragsarten',
          products: 'Produkte',
          exhibitors: 'Aussteller',
        },
      },
      fairGroups: {
        headline: 'Themenwelten',
      },
      types: {
        headline: 'Inhalte',
      },
      categories: {
        headline: 'Kategorien',
      },
      extraCategories: {
        headline: 'Extra Kategorien',
      },
      travelDestinations: {
        headline: 'Reiseziele',
      },
      halls: {
        headline: 'Hallen',
      },
      countries: {
        headline: 'Länder',
      },
      timePeriod: {
        headline: 'Zeitraum',
      },
      timeOfDay: {
        headline: 'Tageszeit',
        options: {
          fullDay: 'Ganzer Tag',
          morning: 'Vormittags',
          afternoon: 'Nachmittags',
        },
      },
      topics: {
        headline: 'Veranstaltung',
      },
    },
    list: {
      place: 'Ort',
      link: 'Hallenplan',
      print: 'Drucken',
      csvDownload: 'Download als xlsx-Datei',
      help: 'Hilfe',
      favourites: 'Meine Merkliste',
      result: 'Ergebnis',
      results: 'Ergebnisse',
      nothingFound: 'Es wurden leider keine Ergebnisse gefunden.',
      useListTooltip: 'Listenansicht verwenden',
      useTileTooltip: 'Kachelansicht verwenden',
      linkToDetail: 'Informationen anzeigen',
      linkToDetailTooltip: 'Gehe zur Detailseite',
      linkToNewsDetail: 'News anzeigen',
      linkToAllNews: 'Alle News anzeigen',
      linkToNewsDetailTooltip: 'Gehe zur Detailseite',
      linkToHallPlan: 'im Hallenplan',
      resetFilters: 'Filter zurücksetzen',
      favouriteTooltip: {
        name: {
          singular: 'Favorit',
          plural: 'Favoriten',
        },
        detail: {
          active: 'Von Favoritenliste entfernen',
          inactive: 'Zur Favoritenliste hinzufügen',
        },
        switch: {
          active: 'Verberge die Favoritenliste',
          inactive: 'Zeige die Favoritenliste an',
        },
        clear: 'Alle Favoriten löschen',
      },
      type: {
        exhibitor: 'Aussteller',
        product: 'Produkt',
        news: 'News',
        brand: 'Marke',
        organizer: 'Veranstalter',
      },
    },
    tabs: {
      all: 'Alles',
      exhibitors: 'AustellerInnen',
      program: 'Programm',
      speaker: 'ReferentInnen',
      news: 'News',
      product: 'Produkte',
    },
    detail: {
      closeTooltip: 'Schließen',
      printTooltip: 'Drucken',
      mailTooltip: 'E-Mail schreiben',
      telephoneTooltip: 'Nummer anrufen',
      faxTooltip: 'Fax schreiben',
      websiteTooltip: 'Webseite aufrufen',
      fair: 'Landesmesse',
      live: 'Jetzt live',
      date: 'Datum',
      loginLink: 'Zur Anmeldung',
      pdfLecture: 'PDF zum Vortrag',
      stream: {
        headline: 'Livestream',
        info: 'Der Livestream ist 10 Minuten vor Beginn des Programms verfügbar.',
      },
      fairBooths: {
        headline: 'Messestand',
        hall: 'Halle',
        booth: 'Stand',
        stage: 'Bühne',
        aisle: 'Gang',
        link: 'im Hallenplan',
        undefined: 'Undefiniert',
        isOnline: 'und Online',
        ebmsState: {
          MAU: 'Mitaussteller',
          VF: 'vertretene Firma',
          AUS: 'Hauptaussteller',
        },
      },
      companyProfile: {
        headline: 'Inhalt',
      },
      badges: {
        headline: 'Sonderauszeichnungen',
      },
      contact: {
        headline: 'Kontakt',
      },
      pointOfContact: {
        headline: 'Ansprechpartner',
      },
      products: {
        headline: 'Produkte',
        link: 'zum Produkt',
      },
      jobs: {
        headline: 'Stellenangebote',
        pdf: 'PDF',
        website: 'zur Website',
      },
      news: {
        headline: 'News',
        link: 'zur News',
        exhibitor: 'Aussteller',
      },
      categories: {
        headline: 'Kategorien',
      },
      extraCategories: {
        headline: 'Extra Kategorien',
      },
      travelDestinations: {
        headline: 'Reiseziele',
      },
      persons: {
        headline: 'Personen',
        moderator: 'Moderation',
        speaker: 'Referentin / Referent',
        speakerFemale: 'Referentin',
        speakerMale: 'Referent',
        lectures: {
          headline: 'Vorträge',
          date: 'Datum',
          booth: 'Raum/ Stand',
          programItem: 'Programmpunkt',
          organizer: 'Veranstalter',
        },
        contact: {
          headline: 'Kontakt',
        },
        vita: {
          headline: 'Vita',
          downloadPdf: 'Vita-PDF herunterladen',
        }
      },
      media: {
        youtube: {
          headline: 'Videos',
        },
        pdf: {
          headline: 'Dokumente',
          download: 'jetzt herunterladen',
        },
        show: 'Jetzt ansehen',
        back: 'Zurück zum Aussteller',
      },
      brands: {
        headline: 'Marken',
      },
    },
    sorting: {
      asc: 'aufsteigend',
      desc: 'absteigend'
    },
  },
  en: {
    global: {
      headline: 'Index of exhibitors',
      searchPlugin: 'Search for exhibitors, products and news ...',
      description: 'English text about the index of exhibitors.',
    },
    navigation: {
      woozle: 'Woozle',
      programmList: 'programm list',
      hallPlan: 'hall plan'
    },
    filter: {
      open: 'Show filter',
      close: 'Hide filter',
      button: 'Filter',
      sort: 'Sort',
      category: 'Category',
      travelDestination: 'Travel dest.',
      spaces: 'Spaces',
      ics: 'ICS Congress Center',
      save: 'Save',
      reset: 'Reset',
      cancel: 'Cancel',
      search: {
        placeholder: 'Please enter search',
        submit: 'Search',
        reset: 'Reset',
      },
      tree: {
        placeholder: 'search...',
        clearValue: 'Clear filter',
        clearAll: 'Clear filter',
        noOptions: 'No filter found',
        noResults: 'No results found',
        noChildren: 'No children found',
        fairTree: {
          headline: 'Fairs',
        },
        typeTree: {
          headline: 'Type',
          products: 'Products',
          exhibitors: 'Exhibitors',
        },
      },
      fairGroups: {
        headline: 'Fair groups',
      },
      types: {
        headline: 'Content',
      },
      categories: {
        headline: 'Categories',
      },
      extraCategories: {
        headline: 'Extra Categories',
      },
      travelDestinations: {
        headline: 'Travel destinations',
      },
      halls: {
        headline: 'Halls',
      },
      countries: {
        headline: 'Countries',
      },
      timePeriod: {
        headline: 'Time period',
      },
      timeOfDay: {
        headline: 'Time of day',
        options: {
          fullDay: 'Full day',
          morning: 'Morning',
          afternoon: 'Afternoon',
        },
      },
      topics: {
        headline: 'Event',
      },
    },
    list: {
      place: 'Place',
      link: 'Hall plan',
      print: 'Print',
      csvDownload: 'Download as xlsx file',
      favourites: 'My favourites',
      help: 'Help',
      result: 'result',
      results: 'results',
      nothingFound: 'No matching results found.',
      useListTooltip: 'Use list view',
      useTileTooltip: 'Use tile view',
      linkToDetail: 'Show information',
      linkToDetailTooltip: 'Go to detail page',
      linkToNewsDetail: 'Show news',
      linkToAllNews: 'Show all news',
      linkToNewsDetailTooltip: 'Go to detail page',
      linkToHallPlan: 'Go to hallplan',
      resetFilters: 'Reset filters',
      favouriteTooltip: {
        name: {
          singular: 'favourite',
          plural: 'favourites',
        },
        detail: {
          active: 'Remove from favourites',
          inactive: 'Add to favourites',
        },
        switch: {
          active: 'Hide favourites',
          inactive: 'Show favourites',
        },
        clear: 'Clear all favourites',
      },
      type: {
        exhibitor: 'Exhibitor',
        product: 'Product',
        news: 'News',
        brand: 'Brand',
        organizer: 'Organizer',
      },
    },
    tabs: {
      all: 'All',
      exhibitors: 'Exhibitors',
      program: 'Programme',
      speaker: 'Speakers',
      news: 'News',
      product: 'Products',
    },
    detail: {
      closeTooltip: 'Close',
      printTooltip: 'Print',
      mailTooltip: 'Send mail',
      telephoneTooltip: 'Call number',
      faxTooltip: 'Send fax',
      websiteTooltip: 'Open website',
      live: 'Now live',
      date: 'date',
      loginLink: 'To the registration',
      pdfLecture: 'PDF about the lecture',
      stream: {
        headline: 'Livestream',
        info: 'The livestream is available 10 minutes before the start of the program.',
      },
      fairBooths: {
        headline: 'Fair booths',
        hall: 'Hall',
        booth: 'booth',
        stage: 'Stage',
        aisle: 'aisle',
        link: 'Hallplan',
        undefined: 'Undefined',
        isOnline: 'and Online',
        fair: 'Fair',
        ebmsState: {
          MAU: 'co-exhibitors',
          VF: 'represented company',
          AUS: 'main exhibitors',
        },
      },
      sorting: {
        asc: 'ascending',
        desc: 'descending'
      },
      companyProfile: {
        headline: 'Content',
      },
      badges: {
        headline: 'Special awards',
      },
      contact: {
        headline: 'Contact',
      },
      pointOfContact: {
        headline: 'Point of contact',
      },
      products: {
        headline: 'Products',
        link: 'go to product',
      },
      jobs: {
        headline: 'Jobs',
        pdf: 'PDF',
        website: 'go to Website',
      },
      news: {
        headline: 'News',
        link: 'go to news',
        exhibitor: 'Exhibitor',
      },
      categories: {
        headline: 'Categories',
      },
      extraCategories: {
        headline: 'Extra Categories',
      },
      travelDestinations: {
        headline: 'Travel destinations',
      },
      persons: {
        headline: 'Persons',
        moderator: 'Moderator',
        speaker: 'Speaker',
        lectures: {
          headline: 'Lectures',
          date: 'Date',
          booth: 'Room/ Booth',
          programItem: 'Program item',
          organizer: 'Organizer',
        },
        contact: {
          headline: 'Contact',
        },
        vita: {
          headline: 'Vita',
          downloadPdf: 'Download Vita-PDF',
        }
      },
      media: {
        youtube: {
          headline: 'Videos',
        },
        pdf: {
          headline: 'Documents',
          download: 'Download now',
        },
        show: 'View now',
        back: 'Back to exhibitor',
      },
      brands: {
        headline: 'Brands',
      },
    },
    sorting: {
      asc: 'ascending',
      desc: 'descending'
    },
  },
  it: {
    global: {},
    filter: {},
    list: {},
    detail: {},
  },
  fr: {
    global: {},
    filter: {},
    list: {},
    detail: {},
  },
  fa: {
    global: {},
    filter: {},
    list: {},
    detail: {},
  },
};

export default labels;
